/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:58:07
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:16:11
 */
import req from "@/utils/request";

//  post
export const addSite = (params) => req.post("/site-service/m/site/setting/update", params);

// 修改
export const getSiteDetail = (params) => req.post("/site-service/m/site/setting/detail", params);
// 模板列表
export const getTemplateList = (params) => req.post("/site-service/m/site/template/list", params);